import { createFileRoute } from "@tanstack/react-router";
import { GuidedPackagingPage } from "@/pages/packaging/GuidedPackaging";

/** A link can open the page at a step (?step=), say which finding it came from (?finding=), and pick the product of an open draft (?draft=). */
export interface GuidedPackagingSearch { step?: string; finding?: string; draft?: string }

export const Route = createFileRoute("/_authenticated/workflows/guided-packaging")({
  // The router reads a numeric value such as finding=5 as a number, so the finding is turned back into text.
  validateSearch: (search: Record<string, unknown>): GuidedPackagingSearch => ({
    step: typeof search.step === "string" ? search.step : undefined,
    finding: search.finding == null ? undefined : String(search.finding),
    draft: typeof search.draft === "string" ? search.draft : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Guided Packaging · Oxley" },
      { name: "description", content: "Upload your catalog, rate features, map value drivers and publish your editions." },
      { property: "og:title", content: "Guided Packaging · Oxley" },
      { property: "og:description", content: "Upload your catalog, rate features, map value drivers and publish your editions." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: GuidedPackagingPage,
});
